"use client"

import type React from "react"
import { GripVertical, X } from "lucide-react"
import { Button } from "@/components/ui/button"

interface DraggableFieldProps {
  children: React.ReactNode
  rowIndex: number
  colIndex: number
  draggable: boolean
  isDropTarget: boolean
  onDragStart: (e: React.DragEvent, rowIndex: number, colIndex: number) => void
  onDragOver: (e: React.DragEvent, rowIndex: number, colIndex: number) => void
  onDragLeave: () => void
  onDrop: (e: React.DragEvent, toRow: number, toCol: number) => void
  onDragEnd: () => void
  onRemove?: () => void
}

export function DraggableField({
  children,
  rowIndex,
  colIndex,
  draggable,
  isDropTarget,
  onDragStart,
  onDragOver,
  onDragLeave,
  onDrop,
  onDragEnd,
  onRemove,
}: DraggableFieldProps) {
  return (
    <div
      draggable={draggable}
      onDragStart={draggable ? (e) => onDragStart(e, rowIndex, colIndex) : undefined}
      onDragOver={draggable ? (e) => onDragOver(e, rowIndex, colIndex) : undefined}
      onDragLeave={draggable ? onDragLeave : undefined}
      onDrop={draggable ? (e) => onDrop(e, rowIndex, colIndex) : undefined}
      onDragEnd={draggable ? onDragEnd : undefined}
      className={`relative ${draggable ? "group cursor-move" : ""} ${
        isDropTarget ? "ring-2 ring-blue-500 rounded" : ""
      }`}
    >
      {draggable && (
        <div className="absolute -left-6 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity z-10">
          <GripVertical className="h-4 w-4 text-muted-foreground" />
        </div>
      )}
      {onRemove && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute -right-2 -top-2 h-5 w-5 opacity-0 group-hover:opacity-100 transition-opacity z-10 hover:bg-destructive hover:text-destructive-foreground"
          onClick={onRemove}
        >
          <X className="h-3 w-3" />
        </Button>
      )}
      {children}
    </div>
  )
}

